import Vue from 'vue'
import VueResource from 'vue-resource'
import store from '../store'
const moment = require('moment')

Vue.use(VueResource)

export default {
  formatMetadataForSelect (metadata) {
    return {
      userRoles: this.formatUserRolesForSelect(metadata.user_roles),
      enginesById: this.formatEngines(metadata.engines),
      reportsById: this.formatReports(metadata.reports),
      selectEngines: this.formatEnginesForSelect(metadata.engines)
    }
  },
  formatReports (reports) {
    let reportsById = {}
    Object.keys(reports).map(function (objectKey, index) {
      reportsById[reports[objectKey].id] = reports[objectKey]
    })
    return reportsById
  },
  formatEngines (engines) {
    let enginesById = {}
    Object.keys(engines).map(function (objectKey, index) {
      enginesById[engines[objectKey].id] = engines[objectKey]
    })
    return enginesById
  },
  formatEnginesForSelect (engines) {
    let enginesSelect = []
    let allowedEngines = []
    if (store.state.user.permissions.is_admin) {
      allowedEngines = Object.keys(this.formatEngines(engines)).map((engineId) => { return parseInt(engineId) })
    } else {
      allowedEngines = store.state.user.permissions.allowed_engine_ids
    }
    Object.keys(engines).map(function (objectKey, index) {
      if (allowedEngines && allowedEngines.includes(engines[objectKey].id)) {
        enginesSelect.push({
          id: engines[objectKey].id,
          name: engines[objectKey].name,
          device_css: 'icon-screen-' + engines[objectKey].device_type,
          country_css: 'fa bfh-flag-' + engines[objectKey].search_link_lang.toUpperCase()
        })
      }
    })
    return enginesSelect
  },
  formatUserRolesForSelect (userRoles) {
    var userRolesSelect = []

    Object.keys(userRoles).map(function (objectKey, index) {
      let role = {
        id: userRoles[objectKey].id,
        name: userRoles[objectKey].name
      }
      userRolesSelect.push(role)
    })
    return userRolesSelect
  },
  removeUnnecessaryRoles (roles) {
    Object.keys(roles).forEach((index) => {
      if (index === 'payment_system') delete roles[index]
    })
    return roles
  },
  decodeUrl (url) {
    try {
      return decodeURIComponent(decodeURIComponent(url))
    } catch (ex) {
      console.log(ex)
      console.log(url)
      return url
    }
  },
  compareOneLvlObjects (o1, o2) {
    for (let p in o1) {
      if (o1.hasOwnProperty(p)) {
        if (o1[p] !== o2[p]) {
          return false
        }
      }
    }
    for (let p in o2) {
      if (o2.hasOwnProperty(p)) {
        if (o1[p] !== o2[p]) {
          return false
        }
      }
    }
    return true
  },
  compareArrays (arr1, arr2) {
    if (!arr1 || !arr2) return false

    // compare lengths - can save a lot of time
    if (arr1.length !== arr2.length) return false

    for (var i = 0, l = arr1.length; i < l; i++) {
      // Check if we have nested arrays
      if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
        // recurse into the nested arrays
        if (!arr1[i].equals(arr2[i])) return false
      } else if (arr1[i] !== arr2[i]) {
        // Warning - two different object instances will never be equal: {x:20} != {x:20}
        return false
      }
    }
    return true
  },
  getChartTooltipLeftPosition (size, point) {
    let leftPosition = 0
    if (point[0] + size.contentSize[0] > size.viewSize[0]) {
      leftPosition = point[0] - (point[0] + size.contentSize[0] - size.viewSize[0])
    } else if (point[0] > size.contentSize[0]) {
      leftPosition = point[0] - size.contentSize[0] / 2
    } else {
      leftPosition = point[0]
    }
    return leftPosition
  },
  numberWithCommas (number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
  getMinDate () {
    let minDate = '1990-01-01'
    if (!store.state.user.permissions.is_admin) {
      let allowedMonths = store.state.metadata.historyMonths[store.state.user.permissions.history_months]
      if (allowedMonths) {
        minDate = moment().add(allowedMonths * (-1), 'month').format('YYYY-MM-DD')
      } else {
        minDate = moment().add(-1, 'days').format('YYYY-MM-DD')
      }
    }
    return minDate
  },
  strListToArray (strList) {
    let arrValues = []

    // check if there are some lines
    var match = /\r|\n/.exec(strList)

    if (match) {
      let arrLines = strList.match(/[^\r\n]+/g)
      arrValues = arrLines.map((line) => {
        return line.split(',').map((keyword) => { return keyword.trim() })
      })
      // join arrays in array
      arrValues = [].concat.apply([], arrValues)
    } else {
      arrValues = strList.split(',').map((keyword) => { return keyword.trim() })
    }

    // remove empty values
    arrValues = arrValues.filter((keyword) => {
      return keyword != null && keyword !== ''
    })

    return arrValues
  }
}



// WEBPACK FOOTER //
// ./src/services/metadata.js